export default "__VITE_ASSET__r0YapLPY__"